<template>
  <v-app id="inspire" class="pb-0">
    <v-navigation-drawer v-model="drawer" app v-if="isAuth">
      <v-list dense>

        <div v-if="menuFilter.length > 0">
          <v-list-item link v-for="item in menuFilter" :key="item.value" >
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>
          </v-list-item>
        </div>

        <v-list-group no-action v-if="showItem('marketing')">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Marketing</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="item in marketing" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>

            <v-list-group sub-group no-action v-if="item.child" style="width: 100%; padding: 0;">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item link v-for="subItem in item.child" :key="subItem.value">
                <router-link class="nav-link menu" :to="subItem.value">{{ subItem.title }}</router-link>
              </v-list-item>
            </v-list-group>

          </v-list-item>
        </v-list-group>

         <v-list-group no-action v-if="showItem('sales')">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Sales</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="item in sales" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>

            <v-list-group sub-group no-action v-if="item.child" style="width: 100%; padding: 0;">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item link v-for="subItem in item.child" :key="subItem.value">
                <router-link class="nav-link menu" :to="subItem.value">{{ subItem.title }}</router-link>
              </v-list-item>
            </v-list-group>

          </v-list-item>
        </v-list-group>

        <v-list-group no-action v-if="showItem('executive')">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Executive</v-list-item-title>
            </v-list-item-content>
          </template>

        <v-list-item link v-for="item in executive" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>

            <v-list-group sub-group no-action v-if="item.child" style="width: 100%; padding: 0;">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item link v-for="subItem in item.child" :key="subItem.value">
                <router-link class="nav-link menu" :to="subItem.value">{{ subItem.title }}</router-link>
              </v-list-item>
            </v-list-group>

          </v-list-item>
        </v-list-group>

        <v-list-group no-action v-if="showItem('reports')">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="item in reportFilter" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Sellnetics</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="item in sellnetics" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>
          </v-list-item>
        </v-list-group>




        <v-divider v-if="user.role == 'Admin'"></v-divider>
        <v-list-group no-action v-if="user.role == 'Admin'">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Administration</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item link v-for="item in administration" :key="item.value">
            <router-link class="nav-link menu" :to="item.value">{{ item.title }}</router-link>

            <v-list-group sub-group no-action v-if="item.child" style="width: 100%; padding: 0;">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item link v-for="subItem in item.child" :key="subItem.value">
                <router-link class="nav-link menu" :to="subItem.value">{{ subItem.title }}</router-link>
              </v-list-item>
            </v-list-group>

          </v-list-item>
        </v-list-group>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="logo">
        <v-img
          :src="logo"
          class="indigo mr-20"
          :eager="true"
          max-height="38"
          max-width="200"
          contain
        ></v-img>
      </div>
      <v-menu
          bottom
          left
          v-if="isAuth"
          offset-y
          :nudge-bottom="20"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              v-bind="attrs"
              v-on="on"
          >
            <span class="mr-2" v-if="$store.getters.authUser">{{ authUser.username }}</span>
            <v-avatar
              color="white"
              size="36"
            >
              <span class="grey--text headline">{{ avatarText }}</span>
            </v-avatar>
          </v-btn>
        </template>
          <v-list dense>
          <v-menu
              bottom
              left
              v-if="isAuth"
              offset-x
              :nudge-left="1"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-bind="attrs"
                  v-on="on"
              >
                <v-list-item-title>Your companies</v-list-item-title>
                <v-list-item-icon>
                  <v-icon v-text="'mdi-play'" x-small></v-icon>
                </v-list-item-icon>
              </v-list-item>

            </template>
              <v-list dense>
                <v-list-item
                    v-for="(item) in availableClients"
                    :key="item.id"
                    @click="setGlobalClientId(item.id)"
                >
                  <v-list-item-title>{{ item.name }} Ads</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-list-item
           @click="openProfile"
          >
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-list-item
           @click="openKeywordQueues"
          >
            <v-list-item-title>Keyword Queues</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="logout"
          >
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-dialog
        v-model="dialogMyProfile"
        width="500"
      >
        <v-card>
          <v-card-title>
            <span class="headline">My Profile</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert
                v-if="errorMessage"
                dense
                type="error"
              >
                {{errorMessage}}
              </v-alert>
              <v-row>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="user.firstName"
                    label="First Name"
                    class="my-0 pa-0"
                    maxlength="50"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span>First Name
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="user.lastName"
                    label="Last Name"
                    class="my-0 pa-0"
                    maxlength="50"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">   
                  <v-select
                    dense
                    :items="user.availableCompanies"
                    item-text="name"
                    item-value="id"
                    v-model="user.availableCompanies"
                    :menu-props="{ maxHeight: '400' }"
                    label="Available companies"
                    multiple
                    outlined
                    class="chip"
                    chips
                    show-select
                    readonly
                  ></v-select>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    type="text"
                    outlined 
                    dense   
                    v-model="user.email"
                    label="Email"
                    class="my-0 pa-0"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1">
                  <v-text-field
                    outlined 
                    dense   
                    v-model="user.password"
                    label="New Password"
                    class="my-0 pa-0"
                    :rules="[rules.passwordRules]"
                    :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'password' : 'text'"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancelProfile">Cancel</v-btn>
            <v-btn color="blue darken-1" text :disabled="validationUser" @click="editProfile">Edit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogKeywordQueues"
        width="500"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Keyword Queues</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="pb-0 pt-1 mt-2" v-if="queueStatus.length == 0">
                  <p style="text-align: center">No Data</p>
                </v-col>
                <v-col cols="12" class="pb-0 pt-1 mt-2" style="border: 1px solid lightgray; border-radius: 5px" v-for="q in queueStatus" :key="q.queueId">
                  <span><b>Campaign:</b> {{q.title}}</span><br>
                  <span><b>Total Keywords:</b> {{ q.countKeywords }}</span>
                  <span class="ml-2"><b>Already Added:</b> {{ q.countAdded }}</span><br>
                  <span><b>Start:</b> {{ q.dateStart }}</span>
                  <span class="ml-2" v-if="q.isDone"><b>End:</b> {{ q.dateEnd }}</span>
                  <v-progress-linear class="mb-2" v-if="!q.isDone" :value="(parseInt(q.countAdded)/parseInt(q.countKeywords))*100"></v-progress-linear>
                  <v-btn v-if="q.isDone" color="blue darken-1" style="padding: 0" text @click="removeQueue(q.queueId)">Remove From History</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <v-main class="px-3 py-0 d-block">
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/api/axios-auth'
export default {
  name: 'index',
  props: {
    source: String,
  },
  watch: {
    drawer: function (val) {
      console.log(this.drawer, val)
    }
  },
  computed: {
    ...mapGetters('auth', {
      isAuth: 'isAuthenticated',
    }),
    validationUser(){
      return !this.user.firstName
    },
    reportFilter(){
      let clientId = localStorage.getItem('ClientId') == null ? 1 : localStorage.getItem('ClientId')
      
      return this.reports.filter(el => el.clients.indexOf(parseInt(clientId)) > -1)
    },
    menuFilter(){
      let clientId = localStorage.getItem('ClientId') == null ? 1 : localStorage.getItem('ClientId')

      return this.menu.filter(el => el.clients.indexOf(parseInt(clientId)) > -1)
    }
  },
  data: () => ({
    drawer: null,
    page: 'home',
    availableClients:[],
    availableMenuItems: [],

    menu:[{title: 'Cruise Campaigns', value: 'cruise-campaigns', clients:[3,4]}],

    marketing:[
      {title: 'Marketing Activity', value: 'marketing-summary', clients:[1,2]},
      {title: 'Marketing Channel Attribution', value: 'marketing-attribution', clients:[1]},
      {title: 'Email Marketing Attribution', value: 'email-campaigns-attribution', clients:[1]},
      {title: 'Marketing Statistics', value: null, child:
            [
              {title: 'Marketing Report', value: 'marketing', clients:[1,2]},
              {title: 'Campaigns', value: 'campaigns'},
            ]
      },
      {title: 'Keyword Bidding Automation', value: null, child:
            [
              {title: 'Cruise Campaigns', value: 'cruise-campaigns'},
              //{title: 'Keywords Report', value: 'keywords-report', clients:[1]},
              {title: 'Keyword Attribution', value: 'keyword-attribution', clients:[1]},
            ]
      }
    ],
    sales:[
        {title: 'Sales Report', value: 'sales', clients:[1]},
        {title: 'Geo Sales Report', value: 'geo-sales', clients:[1]},
        {title: 'Customers Report', value: 'customers'},
        {title: 'Customers Survey', value: 'surveyinfo'},
        {title: 'Sales Activity per Geo Area', value: 'monthly-state-activity'},
        {title: 'Gallons Activity', value: 'gallons'},
        {title: 'CRM Report', value: 'crm-report', clients:[1]},
        {title: 'CRM Customers', value: 'crm-customers'},
        {title: 'Potential Quotes', value: 'potential-gallon', clients:[1]},
    ],
    executive:[
        {title: 'Monthly Activity', value: 'monthly-activity'},
        {title: 'General Metrics Overview ', value: 'general-metrics'},
        {title: 'Call Center', value: 'call-center'},
        {title: 'Call and Web Inquires Report', value: 'call-report'},
        {title: 'Cost per Gallon', value: 'cost-per-gallon'},
    ],
    sellnetics:[

      {title:"Sellnetics", value: 'sellnetics' }
        // {title: 'FO Contacts', value: 'fo-contacts'},
      //{ title: 'Estimations', value: 'estimations'},

      //{title: 'Applicators', value: 'applicators'},

        // {title: 'Building Arhitect', value: 'building-arhitect'}
    ],
    // #menucomponent
    administration: [
      {title: 'Company Management', value: 'company-management'},
      {title: 'User Management', value: 'user-management'},
      {title: 'Import Auction Insights', value: 'import-gai'},
      {title: 'Logs', value: 'logs'},
        {title: 'Logs Jobs', value:'logs-job-component'},
      {title: 'Settings', value: null, child:
            [
              {title: 'Rank', value: 'setting-rank'},
              {title: 'Keyword Mapping', value: 'keyword-mapping'},
              {title: 'Status', value: 'status'}
            ]
      }
    ],

    reports: [
       {title: 'CallRail Report', value: 'callrail', clients:[3,4]},
       {title: 'Web inquiries Report', value: 'web-inquiries-report', clients:[3,4]}
     ],

    avatarText: null,
    errorMessage: null,
    dialogMyProfile: false,
    dialogKeywordQueues: false,
    queueStatus: [],
    user: {
      rights: [],
      email: null,
      password: null,
      firstName: null,
      lastName: null,
      availableCompanies: [],
      role: null,
    },
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 50 || 'Max 50 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
      passwordRules: v => (v && v.length > 8) || 'Password must be more than 8 characters',
    },
    showPassword: true,
    logo: ''
  }),
  mounted() {
    if (localStorage.getItem('token')) {
      axios.get('/users/available-clients').then(response => {
        this.availableClients = response.data.availableClient


        if (this.availableClients.length > 0){
          let clientId = localStorage.getItem('ClientId') == null ? 1 : localStorage.getItem('ClientId')

          let isChangedClient = localStorage.getItem('IsChangedClient')
          let setting = this._.filter(this.availableClients, (o) => {
            return o.id == clientId;
          })[0].uiSettings

          this.logo = this.availableClients.find(e => e.id == clientId).logo

          this.availableMenuItems = setting.availableTabs

          if (isChangedClient && isChangedClient.toString() === "true"){
            localStorage.setItem('IsChangedClient', false)
            this.$router.push({ name: setting.defaultTab })
          }
        }
      });
    }

    this.getUser()

    setInterval(()=>{
      axios.get('/notifications/queue').then(response => {
          this.queueStatus = response.data.data

          this.queueStatus.sort(function compare(a, b) {
            return new Date(b.dateStart) - new Date(a.dateStart);
          });
        })
    }, 30000)
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
    showItem(val) {
      return this.availableMenuItems.indexOf(val) > -1
    },
    setGlobalClientId(id){
      localStorage.setItem('ClientId', id)
      localStorage.setItem('IsChangedClient', true)

      window.location.reload()
    },
    getUser(){
      if (localStorage.getItem('token')) {
        axios.get('/users/me').then(response => {
          this.user.role = response.data.data.role
          this.avatarText = response.data.data.firstName.charAt(0)

          this.user.rights = response.data.data.rights
          this.user.email = response.data.data.email
          this.user.firstName = response.data.data.firstName
          this.user.lastName = response.data.data.lastName
          this.user.availableCompanies = response.data.data.availableCompanies
          this.user.id = response.data.data.id
        })
      }
    },
    openProfile(){
        axios.get('/users/me').then(response => {
          this.user.rights = response.data.data.rights
          this.user.email = response.data.data.email
          this.user.firstName = response.data.data.firstName
          this.user.lastName = response.data.data.lastName
          this.user.availableCompanies = response.data.data.availableCompanies
          this.user.id = response.data.data.id

          this.dialogMyProfile = true
        })
    },
    removeQueue(id){
      axios.delete('/notifications/queue/'+id).then(() => {
        axios.get('/notifications/queue').then(response => {
          this.queueStatus = response.data.data
        })
      })
    },
    openKeywordQueues(){
        axios.get('/notifications/queue').then(response => {
          this.queueStatus = response.data.data

          this.queueStatus.sort(function compare(a, b) {
            return new Date(b.dateStart) - new Date(a.dateStart);
          });

          this.dialogKeywordQueues = true
        })
    },
    closeDialog(){
      this.dialogKeywordQueues = false
    },
    cancelProfile(){
      this.dialogMyProfile = false
      this.getUser()
    },
    editProfile(){
      let data = (this.user.password) 
                  ? { id: this.user.id,
                      firstName: this.user.firstName,
                      lastName: this.user.lastName,
                      password: this.user.password
                    }
                  : { id: this.user.id,
                      firstName: this.user.firstName,
                      lastName: this.user.lastName,
                    }
      axios({
        url: '/users/me',
        method: 'put',
        data: data
      }).then(() => {
          this.errorMessage = null
          this.getUser()
          this.dialogMyProfile = false
          if (this.$route.path == '/user-management') {
            window.location.reload()
          }
        }).catch(error => {
          this.errorMessage = error.response.data
        })
    }
  },
}
</script>

<style>
  ::-webkit-scrollbar {
    width: 0.3em;
    display: inline !important;
    background-color: white;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cacaca;
    scrollbar-color: #cacaca white;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #A8A8A8;
  }
  html {
    overflow-y: auto !important;
    scrollbar-width: none;
  }
   .v-application--is-ltr .v-list--dense .v-list-group--sub-group .v-list-group__header{
     padding: 0!important;
   }
  .v-application--is-ltr .v-list-group--sub-group .v-list-item__action:first-child, .v-application--is-ltr .v-list-group--sub-group .v-list-item__avatar:first-child, .v-application--is-ltr .v-list-group--sub-group .v-list-item__icon:first-child{
     position: absolute;
     right: 0px;
   }
</style>
<style scoped>
   .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item{
     padding-left: 32px;
   }
   .v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > .v-list-item{
     padding-left: 18px;
   }
  .menu {
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1rem;
    color: rgba(0, 0, 0, 0.87) !important;
    letter-spacing: normal;
    text-decoration: inherit;
    min-height: 40px;
    align-items: center;
    display: flex;
    flex: 1 1 100%;
  }
  .router-link-active, 
  .v-list-item--active {
    color: #3F51B5 !important;
  }
  .logo{
  background-size: contain;
  width: 200px;
  height: 38px;
  }
  .logout:hover {
    color: black !important;
  }
  .chip::v-deep .v-chip {
    border-radius: 16px;
    font-size: 13px;
    height: 20px !important;
    color: white;
    background-color: #BDBDBD;
    margin: 4px 4px 0px 4px;
  }
</style>
